<div class="tw-flex tw-h-full tw-flex-col tw-overflow-y-hidden">
    <div class="tw-flex tw-items-center tw-justify-between">
        @if (showText) {
            <div class="mat-title">
                {{ 'GENERAL.DELIVERY' | translate }}
            </div>
        }
        @if (!showText) {
            <div></div>
        }

        <div>
            <button
                mat-icon-button
                mat-dialog-close>
                <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
            </button>
        </div>
    </div>

    @if (pdfSrcData) {
        <ngx-extended-pdf-viewer
            [src]="pdfSrcData"
            [height]="'100%'"
            [showToolbar]="false"
            [showBorders]="false">
        </ngx-extended-pdf-viewer>
    }
</div>
